// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1xfEJ","paramInput":"JobSimulator_paramInput__2W46Q","input":"JobSimulator_input__2ZhRz"};